class AdminRoles {

    constructor()
    {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        new AdminRolesFormValidation('frm-inviteManagerForm-inviteManagerForm');
    }
}
window.AdminRoles = AdminRoles;